import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
let hasGeneratedRoutes = false // 是否已生成路由

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      console.log('=== 权限检查 ===');
      console.log('当前roles长度:', store.getters.roles.length);
      console.log('目标路径:', to.path);
      console.log('是否已生成路由:', hasGeneratedRoutes);

      // 如果已生成路由，直接放行
      if (hasGeneratedRoutes) {
        console.log('路由已生成，直接放行');
        next();
        return;
      }

      // 如果roles已存在，直接放行
      if (store.getters.roles.length > 0) {
        console.log('roles已存在，直接放行');
        next();
        return;
      }

      // 获取用户信息
      console.log('开始获取用户信息...');
      store.dispatch('GetInfo').then(res => {
        console.log('GetInfo 响应:', res);
        console.log('res.data:', res.data);

        // 处理嵌套的数据结构
        const userData = res.data.data || res.data;
        let menus = userData.menus || [];
        let username = userData.username;

        console.log('获取到的菜单:', menus);
        console.log('获取到的用户名:', username);

        // 如果没有菜单，使用默认菜单
        if (!menus || menus.length === 0) {
          console.log('使用默认菜单');
          menus = [
            { id: 1, name: 'pms', title: '商品', icon: 'product', sort: 1, hidden: 0 },
            { id: 2, name: 'oms', title: '订单', icon: 'order', sort: 2, hidden: 0 },
            { id: 3, name: 'sms', title: '营销', icon: 'sms', sort: 3, hidden: 0 },
            { id: 4, name: 'ums', title: '权限', icon: 'ums', sort: 4, hidden: 0 },
            { id: 5, name: 'lottery', title: '抽奖管理', icon: 'lottery', sort: 5, hidden: 0 }
          ];
        }

        store.dispatch('GenerateRoutes', { menus, username }).then(() => {
          console.log('生成的路由:', store.getters.addRouters);
          router.addRoutes(store.getters.addRouters);
          hasGeneratedRoutes = true; // 标记已生成路由
          console.log('用户信息获取完成，标记hasGeneratedRoutes为true');
          next({ ...to, replace: true }); // 确保路由正确跳转
        }).catch((err) => {
          console.error('GenerateRoutes 错误:', err);
          next('/login');
        });
      }).catch((err) => {
        console.error('GetInfo 错误:', err);
        store.dispatch('FedLogOut').then(() => {
          Message.error(err || 'Verification failed, please login again');
        });
        next('/login');
      });
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js